export default __webpack_public_path__ + "_/images/promo_action/instructions/image6-24870281abecabf22e0fdb5ad097f042433a0d5a4e43c56bb9f5d26249b770c7.png";